module.exports = __webpack_public_path__ + "media/before_result.04282651.mp3";